import styled from "styled-components";

export const Container = styled.div`
  max-width: 80%;
  li img {
    width: 52px;
  }

  .copy-link {
    border-radius: 10px;
    border: 1px solid rgba(10, 45, 70, 0.5);
    box-shadow: 0px 4px 100px 0px rgba(0, 0, 0, 0.15);
    display: block;
    font-size: 16px;
    padding: 12px 18px;
    width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/SharePhotoModal/ShareLink/styles.jsx